import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SlideDTO } from '@app/model/slideDTO.model';

@Component({
    selector: 'app-slide-social-wall',
    templateUrl: './slide-social-wall.component.html',
    standalone: false
})
export class SlideSocialWallComponent {
  @Input() public data: SlideDTO;

  private readonly router = inject(Router);

  public navigateToSocialWall(channelId: string): void {
    this.router.navigate(['/social-wall'], {
      queryParams: channelId ? { channel: channelId } : undefined
    });
  }
}
